/*
 * Copyright (c) 2019  Apricot Courses, LLC. All Rights Reserved.
 */

// prod.js - production keys (do commit this)

module.exports = {
  cognitoPoolID: process.env.LL_POOL_ID,
  cognitoClientID: process.env.LL_CLIENT_ID,
  playerScript: process.env.PLAYER_SCRIPT,
};
